module.exports = __webpack_public_path__ + "static/media/menu.65f7610e.svg";